<template>
    <div>
        <st-button
            variant="secondary"
            :callback="addDecisionPurpose"
        >
            <i class="fa fa-plus"></i>
            {{ $t('DECISION_PURPOSE.ADD_BUTTON') }}
        </st-button>

        <decision-purpose-form-modal
            v-if="showModal"
            ref="decisionPurposeFormModal"
            @close="dismissModal"
            :edit-mode="editMode"
        ></decision-purpose-form-modal>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import DecisionPurposeFormModal from '@/modules/decision-purpose/components/DecisionPurposeFormModal.vue';

    export default {
        name: 'DecisionPurposeListToolbar',
        components: { DecisionPurposeFormModal },
        watch: {
            openEditing(newValue, oldValue) {
                if (newValue === oldValue || !newValue) return false;
                this.editMode = true;
                this.showModal = true;
          }
        },
        data() {
            return {
                showModal: false,
                editMode: false,
            };
        },
        computed: {
            ...mapGetters({
                record: 'decisionPurpose/form/record',
                openEditing: 'decisionPurpose/form/openEditing'
            }),
        },
        methods: {
            ...mapActions({
                unselectRecord: 'decisionPurpose/form/unselect',
            }),
            addDecisionPurpose() {
                this.showModal = true;
                this.editMode = false;
            },
            dismissModal() {
                this.showModal = false;
                if (this.editMode) {
                    this.unselectRecord();
                }
            }
        }
    };
</script>

